"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reverseTransformRouteExplicit = exports.reverseTransformRoute = exports.transformRoute = void 0;
exports.targetApi = targetApi;
exports.reverseTargetApi = reverseTargetApi;
// 定义映射关系
const routeMap = {
    // 小写字母
    a: 'z',
    b: 'y',
    c: 'x',
    d: 'w',
    e: 'v',
    f: 'u',
    g: 't',
    h: 's',
    i: 'r',
    j: 'q',
    k: 'p',
    l: 'o',
    m: 'n',
    n: 'm',
    o: 'l',
    p: 'k',
    q: 'j',
    r: 'i',
    s: 'h',
    t: 'g',
    u: 'f',
    v: 'e',
    w: 'd',
    x: 'c',
    y: 'b',
    z: 'a',
    // 大写字母
    A: 'Z',
    B: 'Y',
    C: 'X',
    D: 'W',
    E: 'V',
    F: 'U',
    G: 'T',
    H: 'S',
    I: 'R',
    J: 'Q',
    K: 'P',
    L: 'O',
    M: 'N',
    N: 'M',
    O: 'L',
    P: 'K',
    Q: 'J',
    R: 'I',
    S: 'H',
    T: 'G',
    U: 'F',
    V: 'E',
    W: 'D',
    X: 'C',
    Y: 'B',
    Z: 'A',
};
/**
 * 路由转换方法
 * 将路径中的字母按照映射关系进行转换（a↔z, b↔y等）
 * @param path 原始路径字符串
 * @returns 转换后的路径字符串
 * @example transformRoute("/api/user") // 返回 "/zkr/fhvi"
 */
const transformRoute = (path) => {
    return path
        .split('')
        .map((char) => routeMap[char] || char)
        .join('');
};
exports.transformRoute = transformRoute;
/**
 * 反向路由转换方法
 * 将转换后的路径恢复为原始路径
 * @param path 转换后的路径字符串
 * @returns 原始路径字符串
 * @example reverseTransformRoute("/zkr/fhvi") // 返回 "/api/user"
 */
const reverseTransformRoute = (path) => {
    // 由于映射关系是对称的（a↔z, b↔y等），可以使用相同的映射表进行反向转换
    return path
        .split('')
        .map((char) => routeMap[char] || char)
        .join('');
};
exports.reverseTransformRoute = reverseTransformRoute;
/**
 * 更明确的反向转换实现（创建反向映射表）
 * 通过显式创建反向映射表来进行转换，逻辑更清晰
 * @param path 转换后的路径字符串
 * @returns 原始路径字符串
 */
const reverseRouteMap = {};
Object.keys(routeMap).forEach((key) => {
    reverseRouteMap[routeMap[key]] = key;
});
const reverseTransformRouteExplicit = (path) => {
    return path
        .split('')
        .map((char) => reverseRouteMap[char] || char)
        .join('');
};
exports.reverseTransformRouteExplicit = reverseTransformRouteExplicit;
/**
 * 构建转换后的完整API URL
 * @param base 基础URL
 * @param url 需要转换的路径
 * @returns 转换后的完整URL
 * @example targetApi("https://api.com", "/user/info") // 返回 "https://api.com/fhvi/rmul"
 */
function targetApi(base, url) {
    const formattedUrl = (0, exports.transformRoute)(url);
    return base + formattedUrl;
}
/**
 * 反向API构建函数
 * 从转换后的完整URL中恢复原始路径
 * @param transformedUrl 转换后的完整URL
 * @param base 基础URL
 * @returns 原始路径
 * @example reverseTargetApi("https://api.com/fhvi/rmul", "https://api.com") // 返回 "/user/info"
 */
function reverseTargetApi(transformedUrl, base) {
    // 移除base部分，获取转换后的路径
    const transformedPath = transformedUrl.replace(base, '');
    // 进行反向转换
    const originalPath = (0, exports.reverseTransformRoute)(transformedPath);
    return originalPath;
}
